import { h } from 'preact';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Skeleton from '@mui/material/Skeleton';

import styles from '../../components/global.css';
import LazyLcpIssueRecord from '../../components/lcpIssueRecord/lazyLcpIssueRecord.jsx';

import { IssueTable } from './_common.jsx';
import LazyDateSelect from '../../components/dateSelect/lazyDateSelect.jsx';

export default function LazyLcpIssueList(_props) {
  return (
    <>
      <AppBar
        position="static"
        color="transparent"
        elevation={0}
        sx={{ mt: -4 }}
      >
        <Skeleton width={'100%'} height={48} />
      </AppBar>
      <Paper className={styles.originArea}>
        <div className={styles.urlListHeader}>
          <Typography variant="h5">
            <Skeleton width={'40%'} height={24} />
          </Typography>
          <div>
            <LazyDateSelect />
          </div>
        </div>
        <IssueTable>
          {Array(15)
            .fill(null)
            .map((_, index) => (
              <LazyLcpIssueRecord key={index} />
            ))}
        </IssueTable>
      </Paper>
    </>
  );
}
